/**
 * Bedtime dark-mode prompt (letter_quest/spec/REDESIGN.md §2.1).
 * Shared keys with Flutter SharedPreferences.
 */

export const BEDTIME_PROMPT_DISABLED_KEY = 'bedtime_dark_prompt_disabled';
export const BEDTIME_PROMPT_LAST_SHOWN_KEY = 'bedtime_dark_prompt_last_shown_date';

export function bedtimePromptLocalDateKey(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Evening window: 20:00–05:59 local. */
export function isBedtimePromptWindow(date = new Date()) {
  const hour = date.getHours();
  return hour >= 20 || hour < 6;
}

export function loadBedtimePromptSnapshot() {
  if (typeof localStorage === 'undefined') {
    return { disabled: false, lastShownDateKey: null };
  }
  return {
    disabled: localStorage.getItem(BEDTIME_PROMPT_DISABLED_KEY) === 'true',
    lastShownDateKey: localStorage.getItem(BEDTIME_PROMPT_LAST_SHOWN_KEY),
  };
}

export function shouldOfferBedtimeDarkPrompt({ darkMode, now = new Date() }) {
  const { disabled, lastShownDateKey } = loadBedtimePromptSnapshot();
  if (disabled) return false;
  if (!isBedtimePromptWindow(now)) return false;
  if (darkMode) return false;
  if (lastShownDateKey === bedtimePromptLocalDateKey(now)) return false;
  return true;
}

export function recordBedtimePromptShownToday(now = new Date()) {
  localStorage.setItem(
    BEDTIME_PROMPT_LAST_SHOWN_KEY,
    bedtimePromptLocalDateKey(now),
  );
}

export function recordBedtimePromptNeverAsk() {
  localStorage.setItem(BEDTIME_PROMPT_DISABLED_KEY, 'true');
}
